import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { filterDataProps } from "../../utils/FilterDataProps.js";
import { st, classes } from "./CoreInputWithOptions.st.css";
import { OptionFactory } from "../CoreDropdownOption/OptionFactory.js";
import { CoreDropdown } from "../CoreDropdown/CoreDropdown.js";
import { CoreInput } from "../CoreInput/CoreInput.js";
const DataHooks = {
  input: "input",
  emptyState: "input-with-options-empty-state"
};
class CoreInputWithOptions extends React.PureComponent {
  dropDownRef = null;
  static displayName = "CoreInputWithOptions";
  static defaultProps = {
    openTrigger: "click",
    placement: "bottom-start",
    multi: false,
    initialSelectedIds: [],
    highlightMatches: true,
    onSelect: () => null,
    onDeselect: () => null,
    onManualInput: () => null,
    onInitialSelectedOptionsSet: () => null,
    filterPredicate: (inputValue, optionValue) => optionValue.toLowerCase().includes(inputValue.toLowerCase())
  };
  static bypassDefaultPropsTypecheck;
  isEditing = false;
  state = {
    ariaActivedescendant: null,
    ariaExpanded: false
  };
  _setDropDownRef = (ref) => {
    this.dropDownRef = ref;
  };
  open() {
    this.dropDownRef && this.dropDownRef.open();
  }
  close() {
    this.dropDownRef && this.dropDownRef.close();
  }
  changeExpanded = (isExpanded) => {
    this.setState({ ariaExpanded: isExpanded });
  };
  _filterOptions() {
    const {
      highlightMatches,
      inputProps,
      options,
      filterPredicate,
      emptyStateMessage,
      emptyStateStyle
    } = this.props;
    if (!inputProps.value || !this.isEditing) {
      return options;
    }
    const filteredOptions = options.filter(
      (option) => !option.isSelectable && option.value || option.isSelectable && option.value && filterPredicate(inputProps.value, option.value)
    );
    if (!highlightMatches) {
      return filteredOptions;
    }
    if (emptyStateMessage && filteredOptions.length === 0) {
      return [
        OptionFactory.create({
          render: () => /* @__PURE__ */ jsx("div", { "data-hook": DataHooks.emptyState, style: emptyStateStyle || {}, children: emptyStateMessage }),
          isDisabled: true
        })
      ];
    }
    return filteredOptions.map(
      (option) => option.isSelectable && option.value ? OptionFactory.createHighlighted(option, inputProps.value) : option
    );
  }
  onOptionHover = (option) => {
    const ariaActivedescendant = option ? option._DOMid : null;
    this.setState({ ariaActivedescendant });
  };
  _onSelect = (option) => {
    this.isEditing = false;
    const { onSelect, onManualInput, inputProps } = this.props;
    if (option) {
      onSelect(option);
    } else {
      onManualInput(inputProps.value);
    }
    this.setState({ ariaActivedescendant: null });
  };
  _onKeyDown = (event) => {
    if (!event.key.startsWith("Arrow")) {
      this.isEditing = true;
      this.setState({ ariaActivedescendant: null });
    }
    const { onKeyDown } = this.props.inputProps;
    onKeyDown && onKeyDown(event);
  };
  _onFocus = (event) => {
    this.isEditing = false;
    const { onFocus } = this.props.inputProps;
    onFocus && onFocus(event);
  };
  _onBlur = (event) => {
    if (this.isEditing) {
      this._onSelect(null);
    }
    const { onBlur } = this.props.inputProps;
    onBlur && onBlur(event);
  };
  _onContentMouseDown = (e) => {
    const { onContentMouseDown } = this.props;
    this.isEditing = false;
    onContentMouseDown && onContentMouseDown(e);
  };
  render() {
    const {
      placement,
      openTrigger,
      initialSelectedIds,
      onInitialSelectedOptionsSet,
      multi,
      fixedFooter,
      fixedHeader,
      timeout,
      onDeselect,
      inputProps,
      forceContentElementVisibility,
      style: inlineStyles,
      id,
      allowReselect,
      flip,
      fixed,
      moveBy,
      optionsContainerZIndex,
      appendTo,
      className,
      dynamicWidth
    } = this.props;
    const contentId = id ? `${id}-content` : null;
    const filteredOptions = this._filterOptions();
    const firstOption = filteredOptions.length ? filteredOptions[0].id : null;
    return /* @__PURE__ */ jsx(
      CoreDropdown,
      {
        className: st(classes.root, className),
        placement,
        openTrigger,
        disabled: inputProps.disabled,
        onSelect: this._onSelect,
        onOptionHover: this.onOptionHover,
        fixedFooter,
        fixedHeader,
        onDeselect,
        initialSelectedIds,
        onInitialSelectedOptionsSet,
        options: this._filterOptions(),
        timeout,
        multi,
        forceContentElementVisibility,
        style: inlineStyles,
        ref: this._setDropDownRef,
        allowReselect,
        flip,
        fixed,
        moveBy,
        onContentMouseDown: this._onContentMouseDown,
        contentId,
        onExpandedChange: this.changeExpanded,
        optionsContainerZIndex,
        appendTo,
        dynamicWidth,
        contentRole: "listbox",
        focusOnOption: firstOption,
        dropdownA11yFixes: true,
        ...filterDataProps(this.props),
        children: /* @__PURE__ */ jsx(
          CoreInput,
          {
            "data-hook": DataHooks.input,
            ...inputProps,
            role: "combobox",
            "aria-autocomplete": "both",
            "aria-controls": contentId,
            "aria-expanded": this.state.ariaExpanded,
            "aria-activedescendant": this.state.ariaActivedescendant,
            onKeyDown: this._onKeyDown,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            className: classes.inputComponent
          }
        )
      }
    );
  }
}
export {
  CoreInputWithOptions,
  DataHooks
};
//# sourceMappingURL=CoreInputWithOptions.js.map
